import { ViewModel } from 'view_models/view_model'
import { RequestForm } from 'entities/request_form'

export class RequestFormViewModel extends ViewModel<RequestForm> {
    public printedAtText = () => {
        return this.toDateTimeText(this.object.printedAt)
    }

    public collectedAtText = () => {
        return this.toDateTimeText(this.object.collectedAt)
    }
}
